module.exports = __webpack_public_path__ + "img/icon-outdoor.5771a8e2.svg";